// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "driver-form fieldset table {\n  width: 100%;\n  border-spacing: 1mm;\n}\ndriver-form fieldset td:nth-of-type(1) {\n  width: 180px;\n}\ndriver-form input.small {\n  width: 95%;\n}\ndriver-form input.long {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
